import { UserResponseType } from "types/AuthResponseType";
import ConsentManager from "utils/ConsentManager";
import * as Sentry from "@sentry/browser";

function addAdvertisingCookies() {
  ConsentManager.setIntegrations({ "Google Tag Manager": true });
}

function removeAdvertistingCookies(override = false) {
  ConsentManager.setIntegrations(
    { "Google Tag Manager": false },
    false,
    override,
  );
}

/*
  It's possible that there are instances where we didn't clear the cookie
  settings properly if a teacher and a student shared a computer,
  and that teacher explicitly accepted marketing cookies.
  This function checks for this case and reports it so we can quantify
  the impact of it in production, if any.
*/
function reportCookieSettingsUserConflictIfNeeded() {
  if (ConsentManager.didUserSetPreferences()) {
    const integrations = ConsentManager.integrations();
    const isMarketingEnabled = Object.values(integrations).some(
      (state) => state,
    );
    if (isMarketingEnabled) {
      Sentry.captureException(new Error("Consent Manager Error"));
    }
  }
  return false;
}

export default function resetCookieSettings(currentUser: UserResponseType) {
  const isTeacher = currentUser.type === "Teacher";

  isTeacher
    ? addAdvertisingCookies()
    : removeAdvertistingCookies(currentUser.type === "Student");

  if (currentUser.type === "Student") {
    reportCookieSettingsUserConflictIfNeeded();
  }
}
